
import { Dropdown, Offcanvas } from 'bootstrap';
import './common.js';
import '../css/penaltylog.css';

 fetch("menu.html")
    .then(res => res.text())
    .then(data => {
      const placeholder = document.getElementById("menu-placeholder");
      placeholder.innerHTML = data;

      // Initialize dropdowns and offcanvas manually after injection
      placeholder.querySelectorAll('.dropdown-toggle').forEach(el => new Dropdown(el));
      placeholder.querySelectorAll('.offcanvas').forEach(el => new Offcanvas(el));
    });

  fetch("clubModal.html")
    .then(res => res.text())
    .then(html => document.getElementById("shared-modals").innerHTML = html);